export default function () {
	const audios = document.querySelectorAll(".global-audios__wrapper");
	if (!audios.length) return;
	const sectionAudios = document.querySelectorAll(".global-audios");
	const playBtns = document.querySelectorAll(".global-audios__play");
	const players = [];

	const setBtn = (btn, isPlaying) => {
		let el = btn;
		if (el.classList.contains("global-guided-meditations__play-btn"))
			el = btn.parentNode.querySelector(".play-btn");
		el.dataset.playing = isPlaying;
		if (el.classList.contains("play-btn")) {
			let h = el.dataset.heading || "Audio";
			el.title = isPlaying ? `Pause ${h}` : `Play ${h}`;
			el.ariaLabel = isPlaying ? `Pause ${h}` : `Play ${h}`;
		}
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const intersecting = entry.isIntersecting;
			players.forEach((player, index) => {
				if (intersecting === false) {
					player.pause();
					player.currentTime = 0;
					setBtn(playBtns[index], false);
				}
			});
		});
	});

	sectionAudios.forEach((section) => {
		observer.observe(section);
	});

	audios.forEach((audio, index) => {
		players.push(new Audio(audio.getAttribute("data-audio-meditation")));

		players[index].setAttribute("type", "audio/mpeg");
		players[index].setAttribute("preload", "metadata");

		players[index].addEventListener("ended", () => {
			setBtn(playBtns[index], false);
		});

		playBtns[index].addEventListener("click", () => {
			players.forEach((player, i) => {
				if (i === index) return;
				player.pause();
				player.currentTime = 0;
				setBtn(playBtns[i], false);
			});
			players[index].paused ? players[index].play() : players[index].pause(),
				(players[index].currentTime = 0);
			setBtn(playBtns[index], players[index].paused ? false : true);
		});
	});
}
